<template>
  <div class="findPatient-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span>{{$t('findP')}}</span>
          </div>
          <div class="main-header-right"  :class="{'de22':isDe||isFr,'cz11':isCz}">
            <img src="../assets/back.png">
            <p @click="back">{{$t('home')}}</p>
          </div>
        </div>
        <hr class="small-hr">

        <div class="search" v-show="isA">
           <p>{{$t('enterU')}}</p>
           <input v-model="username">
           <button @click="search">{{$t('search')}}</button>
        </div>

        <div class="search-result" v-show="isB">
          <p>{{$t('searchR')}}</p>
          <hr class="small-hr">

          <div class="content" v-show="isC">
            <div class="result">
              <img src="../assets/User-1.png">
              <div class="user">
                <p>{{this.user.realname}}</p>
                <p class="name">{{$t('uername')}}: {{this.user.username}}</p>
              </div>
            </div>
            <div class="operate">
              <button @click="request">{{$t('sendR')}}</button>
            </div>
          </div>
          <div class="content" v-show="isD">
            <div class="result2">
              <img src="../assets/User-1.png">
              <div class="user">
                <p>{{this.user.realname}}</p>
                <p>{{$t('uername')}}:{{this.user.username}}</p>
                <p>{{$t('Bio')}}: <span>{{mark}}</span></p>
              </div>
            </div>
            <div class="operate">
              <button @click="goCharts">{{$t('viewG')}}</button>
              <button class="remove" @click="Remove">{{$t('remove')}}</button>
            </div>
          </div>
          <div class="content" v-show="isE">
              <div class="result2">
                <img src="../assets/User-1.png">
                <div class="user">
                  <p>{{this.user.realname}}</p>
                  <p>{{$t('uername')}}: {{this.user.username}}</p>
                </div>
              </div>
              <div class="operate">
                <button class="remove" @click="cancelRequest">{{$t('cancelR')}}</button>
              </div>
          </div>
        </div>
      </el-card>
      <div class="Hcp-footer">
      <span>
<!--        <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
                      <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

           {{$t('copyright')}}<br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
      </span>
      </div>

      <!--remark对话框-->
      <el-dialog  :visible.sync="Remark" size="tiny" id="remark-form" :show-close="false" >
        <div slot="title" class="patientList-dialog-title">
          <span>Set remark</span>
          <img src="../assets/cancel.png" @click="cancel">
        </div>
        <div slot class="dialog-body">
          <p>Please input remark in the following box</p>
          <input>
        </div>

        <div slot="footer" class="patientList-dialog-footer">
          <button  class="confirmButton" >Confirm</button>
          <button  class="cancelButton" @click="cancel">Cancel</button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import auth from '../auth/auth'
  import format from '@/lib/format'
  export default{
    data(){
      return{
        isA:true, isB:false, isC: false, isD:false, Remark:false, isE:false,isEs:false,isDe:false,
        username:'',user:[],mark:' ',uids:[],isFr:false,isZh:false,isCz:false,
        isEU:true,
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
      }
    },
    methods:{
      search(){
          let params = {
              username:this.username,
          };
          if(this.username===''){
            let tip = this.$t('A name is required');
            this.$message.error(tip);
          } else{
            this.$http.post('api/v2.0/search/patient',{'params':params}).then(function (res) {
              let err =res.body.error;
               //console.log(res);
              if(err === 0){
                this.user = res.data.patient;
                if (this.user.has_relation===true){
                   if(this.user.relation_state==='ACCEPT'){
                     this.isC = false; this.isD = true;this.isE=false;
                     this.mark = (this.user.motton)?this.user.motton:'--';
                     this.uids.push(this.user.uid);
                   }else{
                     this.isC = false; this.isD = false;this.isE=true;
                   }
                }else{
                     this.isC = true ;this.isD = false;this.isE=false;
                }
                this.isA = false;
                this.isB = true;
              }else if(err ===2){
                let tip = this.$t('userNotExist');
                this.$message.error(tip);
              }

            },function(err){
              console.log(err+","+err.body.message);
              this.error = err.body.message
            });
          }

      },
      back(){
          this.$router.push('/PatientList');
      },
      cancel(){
          this.Remark = false;
      },
      goCharts(){
        sessionStorage.setItem('patientId',this.user.uid);
        sessionStorage.setItem('patientName',this.user.username);
        this.$router.push('/monitor');
      },
      request(){
        let param = {
          username:this.username,
        };
        this.$http.post('/api/v2.0/relations/apply',param).then(function (res) {
          //console.log(param);
            let err =res.body.error;
           // console.log(res.data);
            if(err === 0){
              let tip = this.$t('rSent');
              this.$message({
                type: 'success',
                message: tip,
              });
              this.$router.push('PatientList');
            }
          },function(err){
            console.log(err+","+err.body.message);
            this.error = err.body.message
          })
      },
      cancelRequest(){
        let param = {
          username:this.username,
        };
        this.$http.post('/api/v2.0/relations/apply/cancel',param).then(function (res) {
          //console.log(param);
          let err =res.body.error;
          console.log(res.data);
          if(err === 0){
            let tip = this.$t('cancelR');
            this.$message({
              type: 'success',
              message: tip,
            });
            this.$router.push('PatientList');
          }
        },function(err){
          console.log(err+","+err.body.message);
          this.error = err.body.message
        })
      },
      Remove(){
        let tip = this.$t('CancelTip1');
        let tip1 = this.$t('confirm');
        let tip2 = this.$t('Yes');
        let tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(() => {
          let uids = this.uids;
          this.$http.post('api/v2.0/patients/delete',{'uids':uids}).then(function (res) {
                let err =res.body.error;
                if(err === 0){
                  let tip = this.$t('removeConnect');
                  this.$message({
                    type: 'success',
                    message: tip,
                  });
                  this.$router.push('/PatientList')
                }
                },function(err){
                let tip = this.$t('deleteFailed');
                this.$message.error(tip);
          })
        },function () {

        });
      },
    },
    mounted(){
      let lang = sessionStorage.getItem('language');
      this.isEs= (lang==='es')?true:false;
      this.isDe= (lang==='de')?true:false;
      this.isFr= (lang==='fr')?true:false;
      this.isZh= (lang==='zh')?true:false;
      this.isCz= (lang==='cz')?true:false;
      let countryIndex=localStorage.getItem('index');
      //console.info('countryIndex:'+countryIndex);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    },
  }
</script>

<style scoped>
  .findPatient-container{
    height:895px;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:62%;
   *height:100%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  @media screen and (max-width: 1500px){
    .container{
      width:92%;
    }
  }
  .main-container{
    width:97%;
    height:830px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:70px;
    height:20px;
    line-height: 20px;
    margin-right: 1%;
  }
  .de22{
    width:90px;
  }
  .cz11{
    width:80px;
  }
  .main-header-right img{
    display: block;
    margin-top: 5px;
    float: left;
  }
  .main-header-right p{
    float:right;
    color:#0082d2;
    margin-top: 2px;
    cursor: pointer;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto 15px;
    border:none;
  }

  .main-container .search{
    font-family:SFUIText-Regular;
    width:462px;
    margin:150px auto;
  }
  .search p{
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    width:262px;
    margin:0 auto 20px;
  }
  .search input{
    font-family:SFUIText-Regular;
    color:#282828;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:422px;
    height:35px;
    margin-left:20px;
    margin-bottom: 40px;
    padding-left: 4px;
    font-size: 20px;
  }
  .search button,.operate button,.patientList-dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    border-radius:100px;
    width:150px;
    height:28px;
    color:#ffffff;
    border:none;
    outline: none;
    cursor: pointer;
    margin-left: 150px;
    font-size: 15px;
  }
  .search-result{
    font-size: 16px;
    font-family: SFUIText-Regular;
    color:#282828;
  }
  .search-result p{
    width:98%;
    margin:0 auto 10px;
  }
  .search-result .content{
    margin:0 auto;
    width:96%;
  }
  .content .result{
    float: left;
    width:300px;
  }
  .content img{
    height:50px;
    width:50px;
  }
  .result .user{
    width:250px;
    float: right;
    padding-top: 4px;
  }
  .result p{
    height:14px;
  }
  .content .operate{
    float: right;
    margin-top: 10px;
  }

  .content .result2{
    width:300px;
    float: left;
  }
  .result2 .user{
    width:250px;
    float: right;
    height: 60px;
  }
  .result2 img{
    margin-top: 5px;
  }
  .result2 p{
    height:12px;
  }
  .result2 span{
    color:#009fdf;
    cursor: pointer;
  }
  .operate .remove{
    background-image:linear-gradient(90deg, #c0c0c0 0%, #aaaaaa 100%);
    box-shadow:0 3px 4px 0 #cbcbcb;
    margin-left: 20px;
  }

  /*对话框*/
  #remark-form{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(-90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:90%;
    text-align:left;
    margin:30px 0 10px 20px;
  }
  .dialog-body p{
    margin-bottom: 21px;
    letter-spacing:-0.39px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
  }
  .dialog-body input{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:100%;
    height:35px;
    font-size:20px;
    padding-left: 5px;
  }
  .patientList-dialog-footer {
    width: 90%;
    margin-left: -10px;
    margin-bottom: 10px;
  }
  .patientList-dialog-footer .confirmButton{
    margin-left: 0;
    width:32%
  }
  .patientList-dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 15%;
    width:32%
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
    margin-bottom: 10px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }
</style>



// WEBPACK FOOTER //
// findPatient.vue?548f008a